/**
* 
*/
import React, { Fragment, useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';

//Apis 
import {
    verifyEmailOTP,
    verifyMobileOTP,
    generateEmailOTP,
    generateMobileOTP,
    authSignUp
} from '../tm-apis';

//Helpers
import { setDefaultEnvObj, gtmSend } from '@tickled-media/web-components.tm-helpers'

//Other Components
import ConfirmWidget from '@tickled-media/web-components.tm-confirm-widget';
import Notification from "@tickled-media/web-components.tm-notification";
import ThreeBounceAnimationIcon from "@tickled-media/web-components.tm-three-bounce-loader";

//Icons
import TapIcon from "./icons/TapIcon"
import CrossRegularSmdBlackIcon from "./icons/CrossRegularSmdBlackIcon";
import ShowPasswordEyeIcon from "./icons/ShowPasswordEyeIcon";
import HidePasswordEyeIcon from "./icons/HidePasswordEyeIcon";
import ErrorValidationIcon from "./icons/ErrorValidationIcon";
import InformationIcon from "./icons/InformationIcon";

//Style files
import cx from 'classnames/bind';
import './style.css';

import CryptoJS from "crypto-js"

const notificationConfig = {device: "desktop", type: "error", title: "Validation Error", duration: 6, placement: "topRight"};

const VerifyOTPWidget = (props) => {
    const {
        user,
        onVerifyOTPClose,
        showVerifyOtpWidget = false,
        email = ``,
        emailWidgetShowAsModal = false,
        onRegisterSuccess,
        onUserRegister,
        customStyles,
        mobileNumber,
        countryCode,
        isoCode,
        type,
        translation
    } = props;

    const otpRef = useRef(null), 
        resendOtpRef = useRef(null),
        otpStartTime = "05:00" ,
        otpTimer = 300, //otpTimer in seconds
        resendOtpTimer = 120 //resend otpTimer in seconds

    const passwordRegex = /^\S{8,15}$/;

    const [isVerifyBtnDisabled, setVerifyBtnDisabled] = useState(true),
        [timer, setTimer] = useState(otpStartTime),
        [isOtpVerified, setOtpVerified] = useState(false),
        [isCreatePasswordShow, setCreatePasswordShow] = useState(false),
        [isConfirmPasswordShow, setConfirmPasswordShow] = useState(false),
        [isOtpTimeout, setOtpTimeout] = useState(false),
        [otpValue, setOtpValue] = useState(``),
        [isResendBtnShow, setResendBtnShow] = useState(false),
        [isLoading, setLoading] = useState(false),
        [name, setName] = useState(``),
        [createPwd, setCreatePwd] = useState(``),
        [confirmPwd, setConfirmPwd] = useState(``),
        [isSubmitBtnDisabled, setSubmitBtnDisabled] = useState(true),
        [showConfirmWidget, setShowConfirmWidget] = useState(false),
        [isErrorShow, setErrorShow] = useState(),
        [errorMessage, setErrorMessage] = useState(``),
        [isInvalidPwd, setInvalidaPwd] = useState(false),
        [inputRequired, setInputRequired] = useState(false),
        [isPwdDoesnotMatch, setPwdDoesNotmatch] = useState(false),
        // [isRegisterSuccessfully, setRegisterSuccessfully] = useState(false),
        [resendOtpCounter, setResendOtpCounter] = useState(0),
        [showSpamError, setShowSpamError] = useState(false);

    useEffect(()=>{
        // password input validation
        const isPasswordValid = passwordRegex.test(createPwd);
        setInvalidaPwd(createPwd.length > 0 && !isPasswordValid);
        if (!isPasswordValid || !confirmPwd || createPwd.length === 0 || confirmPwd.length < 8) {
            setSubmitBtnDisabled(true);
            setPwdDoesNotmatch(false);
        } else {
            // confirm password input validation
            const doPasswordsMatch = createPwd === confirmPwd;
            setPwdDoesNotmatch(!doPasswordsMatch);
            setSubmitBtnDisabled(!doPasswordsMatch);
        }
    },[createPwd, confirmPwd])

    useEffect(() => {
        if(showVerifyOtpWidget) {
            clearOtpTimer(getOtpDeadTime());
            clearResendOtpTimer(getResendDeadTime());
        }
    }, [showVerifyOtpWidget]);

    // useEffect(() => {
    //     if(isRegisterSuccessfully) {
    //         setShowConfirmWidget(false)
    //         onVerifyOTPClose(false)
    //         if(onRegisterSuccess) onRegisterSuccess(true);
    //     }
    // },[isRegisterSuccessfully])

    useEffect(() => {
        if(resendOtpCounter !== 0 && resendOtpCounter === 2) {
            setShowSpamError(true);
            setErrorShow(true);
            setOtpVerified(false);
            type === 'email' ? setErrorMessage(translation[`optCheckSpamText`]) : setErrorMessage(translation['smsNotReceived']);
        }else {
            setShowSpamError(false);
        }
    },[resendOtpCounter])

    const handleOTP = (e) => {
        const inputs = document.querySelectorAll(`.otp-section-wrap input`);
        const input = e.target;
        const inputValues = document.getElementsByClassName(`otp-input`);
        const value = input.value;
        const fieldIndex = input.dataset.index;

        if (fieldIndex < inputs.length - 1 && value !== ``) {
            input.nextElementSibling.focus();
        }
    
        if (e.key === "Backspace" && fieldIndex > 0) {
            input.previousElementSibling.focus();
        }

        if (fieldIndex == inputs.length - 1 && value !== ``) {
            onOtpSubmit();
        } else if(value !== ``) {
            if(document.getElementsByClassName(`otp-input`)) {
                for(let i=0;i<inputValues.length; i++) {
                    if(inputValues[i].value !== ``) {
                        onOtpSubmit();
                        setVerifyBtnDisabled(false);
                    } else {
                        setVerifyBtnDisabled(true);
                    }
                }
            }    
        }else {            
            setVerifyBtnDisabled(true);
        }
    }

    const handleOnPasteOtp = (e) => {
        const data = e.clipboardData.getData("text");
        const inputs = document.querySelectorAll(`.otp-section-wrap input`);
        const value = data.split("");
        
        if (value.length === inputs.length) {
            inputs.forEach((input, index) => {input.value = value[index] });
            onOtpSubmit();
        }
    }

    const onOtpSubmit = () => {
        const inputs = document.querySelectorAll(`.otp-section-wrap input`);
        let otp = "";
        inputs.forEach((input) => {
            otp += input.value;
        });
        setOtpValue(otp);
        setVerifyBtnDisabled(false);
    }

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        return {
            total, minutes, seconds
        };
    }

    const startOtpTimer = (e) => {
        const { total, minutes, seconds } = getTimeRemaining(e);
        if (total >= 0) {
            setTimer( (minutes > 9 ? minutes : '0' + minutes) + ':' + (seconds > 9 ? seconds : '0' + seconds))
        } else {
            setOtpTimeout(true);
            setErrorShow(false);
            clearInterval(otpRef.current)
        }
    }

    const clearOtpTimer = (e) => {
  
        setTimer(otpStartTime);
  
        if (otpRef.current) clearInterval(otpRef.current);

        const id = setInterval(() => {
            startOtpTimer(e);
        }, 1000)

        otpRef.current = id;
    }

    const getOtpDeadTime = () => {
        const deadline = new Date();
        deadline.setSeconds(deadline.getSeconds() + otpTimer);
        return deadline;
    }

    const onClickReset = () => {
        clearOtpTimer(getOtpDeadTime());
    }

    const startResendOtpTimer = (e) => {
        const { total } = getTimeRemaining(e);
        if (total >= 0) {
        } else {
            setResendBtnShow(true);
            clearInterval(resendOtpRef.current)
        }
    }

    const clearResendOtpTimer = (e) => {
  
        setTimer(otpStartTime);
  
        if (resendOtpRef.current) clearInterval(resendOtpRef.current);

        const id = setInterval(() => {
            startResendOtpTimer(e);
        }, 1000)

        resendOtpRef.current = id;
    }

    const getResendDeadTime = () => {
        const deadline = new Date();
        deadline.setSeconds(deadline.getSeconds() + resendOtpTimer);
        return deadline;
    }

    const resetOtpTimer = () => {
        clearResendOtpTimer(getResendDeadTime());
    }


    const onVerifyOtp = () => {
        setResendOtpCounter(0);
        setErrorShow(false);
        if(isVerifyBtnDisabled) {
            return;
        }

        if(type === 'email'){
            const formData = new FormData();
            formData.append('otp', otpValue);
            formData.append('identifier', email);
            formData.append('source', `sign-up`);
            
            gtmSend(`loginSignup`, `Login and Signup`, `Verify OTP by Email`, `--`, 0 , {"action_detail" : "Verify OTP by Email"})
            setLoading(true);
            verifyEmailOTP(setDefaultEnvObj(user), user, formData)
                .then((response) => {
                    setLoading(false);
                    setOtpTimeout(false);
                    if (response?.status === 200 && response?.data?.status) {
                        setOtpVerified(true);
                        setErrorShow(false);
                        Notification.send({
                            ...notificationConfig,
                            type: "info",
                            title: translation[`notification`],
                            message: response?.data?.message
                        });
                    } else {
                        gtmSend(`loginSignup`, `Login and Signup`, `OTP Error`, `${response?.data?.message ? response.data.message : translation['somethingWentWrong']}`, 0 , {"action_detail" : "OTP Error"})
                        setErrorShow(true);
                        setOtpVerified(false);
                        setErrorMessage(response?.data?.message ? response.data.message : translation['somethingWentWrong']);
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    console.warn("Error", error);
                })
        }else{
            const formData = new FormData();
            formData.append('otp', otpValue);
            formData.append('identifier', mobileNumber);
            formData.append('country_iso_code', isoCode);
            formData.append('source', `sign-up`);
            
            gtmSend(`loginSignup`, `Login and Signup`, `Verify OTP by Mobile Number`, `--`, 0 , {"action_detail" : "Verify OTP by Mobile Number"})
            setLoading(true);
            verifyMobileOTP(setDefaultEnvObj(user), user, formData)
                .then((response) => {
                    setLoading(false);
                    setOtpTimeout(false);
                    if (response?.status === 200 && response?.data?.status) {
                        setOtpVerified(true);
                        setErrorShow(false);
                        Notification.send({
                            ...notificationConfig,
                            type: "info",
                            title: translation[`notification`],
                            message: response?.data?.message
                        });
                    } else {
                        gtmSend(`loginSignup`, `Login and Signup`, `OTP Error`, `${response?.data?.message ? response.data.message : translation['somethingWentWrong']}`, 0 , {"action_detail" : "OTP Error"})
                        setErrorShow(true);
                        setOtpVerified(false);
                        setErrorMessage(response?.data?.message ? response.data.message : translation['somethingWentWrong']);
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    console.warn("Error", error);
                })
        }
    }

    const onResendOtpClick = () => {
        setResendBtnShow(false);
        setLoading(true);
        setErrorShow(false);
        setErrorMessage(`setErrorShow`);
        setOtpValue(``);
        setOtpTimeout(false);
        setVerifyBtnDisabled(true);

        if(document.getElementsByClassName(`otp-input`)) {
            const inputValues = document.getElementsByClassName(`otp-input`);
            for(let i=0;i<inputValues.length; i++) {
                inputValues[i].value = ``;
            }
        }

        if(type === 'email'){
            const formData = new FormData();
            formData.append('identifier', email);
            formData.append('source', `sign-up`);
            formData.append('resend', 1);
    
            gtmSend(`loginSignup`, `Login and Signup`, `Resend OTP by Email`, `--`, 0 , {"action_detail" : "Resend OTP by Email"})
    
            generateEmailOTP(setDefaultEnvObj(user), user, formData)
                .then((response) => {
                    if (response?.status === 200 && response?.data?.status) {
                        Notification.send({
                            ...notificationConfig,
                            type: "info",
                            title: translation[`notification`],
                            message: response?.data?.message
                        });
    
                        setResendOtpCounter((counter) => counter + 1)
    
                    }else {
                        setErrorShow(true);
                        setErrorMessage(response?.data?.message ? response.data.message : translation['somethingWentWrong']);
                        setResendOtpCounter(0);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    console.warn("Error", error);
                })
        }else{
            const formData = new FormData();
            formData.append('identifier', mobileNumber);
            formData.append('country_iso_code', isoCode);
            formData.append('source', `sign-up`);
            formData.append('resend', 1);
    
            gtmSend(`loginSignup`, `Login and Signup`, `Resend OTP by Mobile Number`, `--`, 0 , {"action_detail" : "Resend OTP by Mobile Number"})
    
            generateMobileOTP(setDefaultEnvObj(user), user, formData)
                .then((response) => {
                    if (response?.status === 200 && response?.data?.status) {
                        Notification.send({
                            ...notificationConfig,
                            type: "info",
                            title: translation[`notification`],
                            message: response?.data?.message
                        });
    
                        setResendOtpCounter((counter) => counter + 1)
    
                    }else {
                        setErrorShow(true);
                        setErrorMessage(response?.data?.message ? response.data.message : translation['somethingWentWrong']);
                        setResendOtpCounter(0);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    console.warn("Error", error);
                })
        }
        
        clearOtpTimer(getOtpDeadTime());
        clearResendOtpTimer(getResendDeadTime());
    }

    const onEnterPassword = (passwordText) => {
        setCreatePwd(passwordText);
        if(name.length === 0){
            setInputRequired(true)
        }
    }

    const onConfirmPassword = (confirmPasswordText) => {
        setConfirmPwd(confirmPasswordText);
    }

    const onSignupSubmit = (event) => {
        event.preventDefault();
        if(!isSubmitBtnDisabled){
            const key = CryptoJS.enc.Utf8.parse(`tickled012345678`),
                iv = CryptoJS.enc.Utf8.parse(''),
                encryptedCP = CryptoJS.AES.encrypt(createPwd, key, { iv: iv }),
                password = encryptedCP.toString();

            const payload = {};
            if (type === 'email') {
                payload.method = 'email';
                payload.email = email;
            } else {
                payload.method = 'phone';
                payload.phone = countryCode + mobileNumber;
            }
            payload.password = password;
            payload.full_name = name;
            payload.code = otpValue;

            setLoading(true);
            gtmSend(`loginSignup`, `Login and Signup`, `Submit Details via ${type === 'email'? 'Email' : 'Mobile'}`, `--`, 0, { "action_detail": `Submit Details via ${type === 'email'? 'Email' : 'Mobile'}` })
            authSignUp(setDefaultEnvObj(user), user, payload)
                .then((data) => {
                    if (data && data.response && data.status === true) {
                        if (type === 'email') {
                            gtmSend(`loginSignup_signup_successful`, `Login and Signup`, `Sign Up Successful via Email`, `--`, 0, { "action_detail": "Sign Up Successful via Email" })
                            gtmSend(`loginSignup`, `Login and Signup`, `Sign In via Email Address`, `--`, 0, { "action_detail": "Sign In via Email Address" })
                        } else {
                            gtmSend(`loginSignup_signup_successful`, `Login and Signup`, `Sign Up Successful via Mobile`, `--`, 0, { "action_detail": "Sign Up Successful via Mobile" })
                            gtmSend(`loginSignup`, `Login and Signup`, `Sign In via Mobile Number`, `--`, 0, { "action_detail": "Sign In via Mobile Number" })
                        }

                        // setRegisterSuccessfully(true);
                        if (onUserRegister) {
                            onUserRegister(data.response);
                        }
                        // clearState();
                    } else {
                        gtmSend(`loginSignup`, `Login and Signup`, `Sign Up Error`, `${translation['somethingWentWrong']}`, 0, { "action_detail": `Sign Up Error` })
                        Notification.send({
                            ...notificationConfig,
                            type: "info",
                            title: translation[`notification`],
                            message: translation['somethingWentWrong']
                        });
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    console.warn("Error", error);
                    if (error.response && error.response.data) {
                        const data = error.response.data;
                        gtmSend(`loginSignup`, `Login and Signup`, `Sign Up Error`, `${data.error?.message ? data.error?.message :translation['somethingWentWrong']}`, 0, { "action_detail": `Sign Up Error` })
                        Notification.send({
                            ...notificationConfig,
                            type: 'info',
                            title: translation[`notification`],
                            message: data?.message ? data.message : translation['somethingWentWrong'],
                        });
                    }
                })
        }
    }

    const onEmailAppClick = () => {
        window.location.href = `mailto:${email}`;
        gtmSend(`loginSignup`, `Login and Signup`, `Open Email App`, `--`, 0 , {"action_detail" : "Open Email App"})
    }

    const digitValidate = (element) => {
        element.target.value = element.target.value.replace(/[^0-9]/g,'');
    }
    
    const onCloseClick = () => {
        if (isLoading) {
            return;
        }
        setShowConfirmWidget(true);
    }

    const clearState = () => {
        if(document.getElementsByClassName(`otp-input`)) {
            const inputValues = document.getElementsByClassName(`otp-input`);
            for(let i=0;i<inputValues.length; i++) {
                inputValues[i].value = ``;
            }
        }
        setErrorShow(false);
        setErrorMessage(``);
        setOtpTimeout(false);
        setResendBtnShow(false);
        setVerifyBtnDisabled(true);
        setName(``);
        setCreatePwd(``);
        setConfirmPwd(``);
        setOtpVerified(false);
        setSubmitBtnDisabled(true);
        setInputRequired(false);
        setInvalidaPwd(false);
        setPwdDoesNotmatch(false);
        setResendOtpCounter(0);
        setShowSpamError(false);
    }

    const onNameEnter = (e) => {
        if(e.target.value.length === 0){
            setInputRequired(true);
        }else{
            setInputRequired(false);
        }
        setName(e.target.value); 
    }

    return (
        <div className={cx('verifyOTPWidget-view')}>

            { isLoading && <ThreeBounceAnimationIcon /> }
            <div className={cx(`verify-otp-close-icon`)} onClick={() => onCloseClick()}>
                <CrossRegularSmdBlackIcon />
            </div>

            {
                isOtpVerified
                ?
                <div className={cx(`new-user-registraion-form`)}>
                    <TapIcon />
                    <div className={cx(`heading-text`)}>
                        {translation[`signupFormHeading`]}
                    </div>

                    <div className={cx(`description-text`)}>
                        {translation[`signupFormDescription`]}
                    </div>

                    <div>
                        <form onSubmit={onSignupSubmit}>
                            <div className={cx(`element-wrap`)}>
                                <input
                                    type="text"
                                    placeholder={translation[`nameInputPlaceholder`]}
                                    onChange={(e) => onNameEnter(e)}
                                    value={name}
                                    className={cx(`${inputRequired ? 'has-error' : ''}`)}
                                />
                            </div>
                            {
                                inputRequired &&
                                <div className={`error-message-text-verify pwd-error`}>
                                    <span className={cx(`info-icon`)}><ErrorValidationIcon className={cx(`info-svg`)}/></span>
                                    <span className={cx(`text`)}>{translation[`inputRequired`]}</span>
                                </div>
                            }

                            <div className={cx(`element-wrap`)}>
                                <input
                                    type={`${isCreatePasswordShow ? "text" : "password"}`}
                                    placeholder={translation[`createPwdPlaceholder`]}
                                    value={createPwd}
                                    onInput={(e) => onEnterPassword(e.target.value)}
                                    className={cx(`${isInvalidPwd ? 'has-error' : ''}`)}
                                />
                                {
                                    <span onClick={() => setCreatePasswordShow(!isCreatePasswordShow)}>
                                        {isCreatePasswordShow ? <ShowPasswordEyeIcon /> : <HidePasswordEyeIcon />}
                                    </span>
                                }
                            </div>

                            {
                                isInvalidPwd &&
                                <div className={`error-message-text-verify pwd-error`}>
                                    <span className={cx(`info-icon`)}><ErrorValidationIcon className={cx(`info-svg`)}/></span>
                                    <span className={cx(`text`)}>{translation[`pwdNotValidText`]}</span>
                                </div>
                            }
                            

                            <div className={cx(`element-wrap`)}>
                                <input
                                    type={`${isConfirmPasswordShow ? "text" : "password"}`}
                                    placeholder={translation[`confirmPwdPlaceholder`]}
                                    value={confirmPwd}
                                    onInput={(e) => onConfirmPassword(e.target.value)}
                                    className={cx(`${isPwdDoesnotMatch ? 'has-error' : ''}`)}

                                />
                                {
                                    <span onClick={() => setConfirmPasswordShow(!isConfirmPasswordShow)}>
                                        {isConfirmPasswordShow ? <ShowPasswordEyeIcon /> : <HidePasswordEyeIcon />}
                                    </span>
                                }
                            </div>

                            {
                                isPwdDoesnotMatch &&
                                <div className={`error-message-text-verify pwd-error`}>
                                    <span className={cx(`info-icon`)}><ErrorValidationIcon className={cx(`info-svg`)}/></span>
                                    <span className={cx(`text`)}>{translation[`pwdDoesNOtMatchText`]}</span>
                                </div>
                            }
                           

                            <div className={cx(`element-wrap`)}>
                                <button type={`submit`} disabled={!isSubmitBtnDisabled && name.length !== 0 ? false : true} className={cx(`submit-btn ${!isSubmitBtnDisabled && name.length !== 0 ? 'enable' : 'disabled'}`)}>{translation[`submitBtnText`]}</button>
                            </div>
                        </form>
                    </div>
                </div>
                :
                <Fragment>
                    <div className={cx(`enter-otp-text`)}>
                        {type === 'email'? translation[`verifyEmailHeadingText`] : translation[`verifyMobileHeadingText`]}
                        <span>{`(${timer})`}</span>
                    </div>

                    <div className={cx(`one-otp-mail-text-wrap`)}>
                        <span>{translation[`verifyEmailDescriptionText`]}</span>
                        <span className={cx(`email`)}>{type === 'email'? email : `${countryCode} ${mobileNumber}`}</span>
                    </div>

                    {/* <div className={cx(`only-mobile open-email-btn-wrap`)} onClick={() => onEmailAppClick()}>
                        {translation[`openEmailAppText`]}
                    </div> */}

                    <div className={cx(`otp-section-wrap`)}>
                        {
                            [...Array(6).keys()].map((value, index) => {
                                return (
                                    <input type={`tel`}
                                        maxLength={1}
                                        data-index={index}
                                        key={index}
                                        onInput={(e) => digitValidate(e)} 
                                        onKeyUp={handleOTP}
                                        min={"0"}
                                        max={"9"}
                                        className={cx(`otp-input ${isErrorShow ? `${!showSpamError ? 'has-error' : ''}` : ''}`)}
                                        onPaste={handleOnPasteOtp}
                                    />
                                )
                            })
                        }
                    </div>

                    {
                        isErrorShow &&
                        <div className={`error-message-text-verify`}>
                            <span className={cx('info-icon')}>{showSpamError ? <InformationIcon className={cx(`info-svg`)}/> : <ErrorValidationIcon className={cx(`info-svg`)}/>}</span>
                            <span className={cx(`${showSpamError ? 'info-text' : 'text'}`)}>{errorMessage} </span>
                        </div>
                    }
                    {
                        isOtpTimeout &&
                        <div className={cx(`resend-otp-text-wrapper`)}>
                            <div className={cx(`icon-wrap`)}>
                                <ErrorValidationIcon />
                            </div>
                            <div className={cx(`text-wrap`)}>
                                <div className={cx(`otp-timeout-text`)}>
                                    {translation[`otpTimeoutText`]}
                                </div>
                                {
                                    type === 'email' && 
                                    <div className={cx(`otp-check-mail-text`)}>
                                        {translation[`checkMailText`]}
                                    </div>
                                }
                            </div>
                        </div>
                    }
                   

                    <div className={cx(`button-wrap`)}>
                        <button 
                            className={cx(`${isVerifyBtnDisabled ? 'disabled' : 'enable'}`)}
                            onClick={() => onVerifyOtp()}
                            >
                                {translation[`verifyBtnText`]}
                        </button>
                    </div>
    
                    <div className={cx(`resend-btn-wrapper`)}>
                        {translation[`didNotReceiveOptText`]}
                        <span className={cx(`${!isResendBtnShow ? 'disabled' : ''}`)} onClick={() => {if(isResendBtnShow) onResendOtpClick()}}>
                            {translation[`resend`]}
                        </span>
                    </div>
                    
                </Fragment>
            }
            {
                emailWidgetShowAsModal && showConfirmWidget
                    ?
                    <Modal isOpen={emailWidgetShowAsModal}
                        onAfterOpen={() => console.log(`open`)}
                        onRequestClose={() => console.log(`close`)}
                        overlayClassName="confirm-container-myOverlayClass"
                        style={customStyles}
                    >
                        <ConfirmWidget
                            onConfirmWidgetClose={(flag) => {setShowConfirmWidget(flag); }}
                            closePreviousWidget={(flag) => {setOtpVerified(flag); onVerifyOTPClose(flag); clearState();}}
                            goBackToWidget={false}
                            translation={translation}
                            screen={`${isOtpVerified ? 'Detail Screen' : 'OTP Screen'}`}
                            confirmMessage={translation['confirmMessageVerify']}
                        />
                    </Modal>
                    :
                    <div className={`confirm-widget ${showConfirmWidget ? 'show' : 'hide'}`}>
                        <ConfirmWidget
                            onConfirmWidgetClose={(flag) => {setShowConfirmWidget(flag);}}
                            closePreviousWidget={(flag) => {setOtpVerified(flag); onVerifyOTPClose(flag); clearState();}}
                            goBackToWidget={false}
                            translation={translation}
                            screen={`${isOtpVerified ? 'Detail Screen' : 'OTP Screen'}`}
                            confirmMessage={translation['confirmMessageVerify']}
                        />
                    </div>
            }
        </div>
    )
}

export default VerifyOTPWidget;

